import { render, staticRenderFns } from "./default.vue?vue&type=template&id=ea60d6c4&scoped=true&lang=pug"
import script from "./default.vue?vue&type=script&lang=ts"
export * from "./default.vue?vue&type=script&lang=ts"
import style0 from "./default.vue?vue&type=style&index=0&id=ea60d6c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea60d6c4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CustomizableOverlay: require('/workspace/portal/hosting/components/CustomizableOverlay.vue').default})
